export default __webpack_public_path__ + "static/media/mapPoint.223884f3.svg";